import { useRequiredParams } from '@pba/react-router';
import { GroupDetailAbout, GroupDetailAboutHeader, GroupLayout } from 'features/groups';
import { useGetPathToEntityDetail } from '../../hooks';
import { useNavigateToGroupDetailPageByKey, useNavigateToGroupEntity } from '../hooks';

const PageGroupDetailAbout = () => {
  const { groupId } = useRequiredParams<{ groupId: string }>();
  const getPathToEntityDetail = useGetPathToEntityDetail();
  const navigateToGroupDetailPageByKey = useNavigateToGroupDetailPageByKey();
  const navigateToGroupEntity = useNavigateToGroupEntity();

  return (
    <GroupLayout
      groupId={groupId}
      header={(group) => (
        <GroupDetailAboutHeader group={group} navigateToGroupDetailPageByKey={navigateToGroupDetailPageByKey} />
      )}
    >
      {(group) => (
        <GroupDetailAbout
          getPathToEntityDetail={getPathToEntityDetail}
          group={group}
          navigateToGroupEntity={navigateToGroupEntity}
        />
      )}
    </GroupLayout>
  );
};

export default PageGroupDetailAbout;
